import styled from "styled-components";

export const Container = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #110f14;
    padding: 0;
    position: relative;
  }
`;

export const MenuButton = styled.button<{ position?: "left" | "right" }>`
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  position: absolute;
  ${(props) => props.position || "right"}: 0.5rem;

  /* Prevent highlight on tap (especially on mobile Safari) */
  -webkit-tap-highlight-color: transparent;

  /* Remove focus ring */
  outline: none;

  &:focus {
    outline: none;
  }
`;

export const BackButton = styled.button<{ position?: "left" | "right" }>`
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  position: absolute;
  ${(props) => props.position || "left"}: 0.5rem;

  /* Prevent highlight on tap (especially on mobile Safari) */
  -webkit-tap-highlight-color: transparent;

  /* Remove focus ring */
  outline: none;

  &:focus {
    outline: none;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
  color: white;
`;

export const Logo = styled.img`
  height: 30px;
  cursor: pointer;
`;

export const Menu = styled.div`
  position: absolute;
  top: 60px;
  right: 16px;
  background: #1a1a1a;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;

  &.open {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  border-bottom: 1px solid #444;
  color: white;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const SvgIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: #e5e5e5;
`;

export const SidebarMenu = styled.div<{
  position?: "left" | "right";
  isOpen?: boolean;
}>`
  position: fixed;
  top: 60px;
  ${(props) => (props.position === "left" ? "left: 0;" : "right: 0;")}
  width: 100vw;
  height: calc(100vh - 60px);
  background: #110f14;
  box-shadow: ${(props) =>
    props.position === "left"
      ? "4px 0 6px rgba(0, 0, 0, 0.2)"
      : "-4px 0 6px rgba(0, 0, 0, 0.2)"};
  transform: ${(props) =>
    props.isOpen
      ? "translateX(0)"
      : props.position === "left"
      ? "translateX(-100%)"
      : "translateX(100%)"};
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;

  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};
`;
